<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>List of 3D analytic logs</h3>
            </b-col>
        </b-row>

        <div class="overflow-auto">

            <b-form-group label="Filter by user" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <ejs-dropdownlist id='dropdownlist' placeholder='Users' :allowFiltering='true'
                        :dataSource='list_of_users' :fields='user_select_fields' v-model='filter_by_user'>
                    </ejs-dropdownlist>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by space" label-for="dropdownlist" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <ejs-dropdownlist id='dropdownlist' placeholder='Start typing the name of the space'
                        :allowFiltering='true' :filtering="filtering" :dataSource='list_of_spaces'
                        :fields='space_select_fields' v-model='filter_by_space'>
                    </ejs-dropdownlist>

                </b-input-group>
            </b-form-group>

            <div class="mb-3">
                <b-button @click="download_logs" variant="primary" class="mx-2">Filter</b-button>
                <b-button @click="clear_filter()">Clear filter</b-button>
            </div>


            <b-table id="my-table-users" :fields="fields" :items="list_of_logs" :sort-by.sync="created_at"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" small striped>
                <template v-slot:cell(file_name)="data">
                    <b-link @click="download_log(data.value)">{{ data.value }}</b-link>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(graph)="data">
                    <b-button variant="success" @click="show_graph_modal(data)">Show</b-button>
                </template>
            </b-table>

            <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="perPage" align="fill"
                size="sm"></b-pagination>
        </div>

        <b-modal id="modalPopover" title="User journey graph" size="xl" @shown="show_plotly" ok-only>
            <div class="d-flex justify-content-center mb-3">
                <b-spinner v-if="loading_graph" small label="Loading..." />
            </div>
            <div ref="plotlyGraph"></div>
        </b-modal>

    </b-container>
</template>

<script>
import Alert from '../components/alert.vue';
import Plotly from 'plotly.js';

export default {
    data() {
        return {
            created_at: "created_at",
            sortDesc: true,
            message: '',
            perPage: 20,
            currentPage: 1,
            totalRows: null,
            list_of_logs: null,
            list_of_users: null,
            list_of_spaces: null,
            filter_by_user: null,
            filter_by_space: null,
            fields: [
                { key: 'file_name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'space_name', label: 'Space', class: 'text-center align-middle', sortable: true },
                { key: 'user_email', label: 'User', class: 'text-center align-middle', sortable: true },
                { key: 'created_at', label: 'Created at', class: 'text-center align-middle', sortable: true },
                { key: 'graph', label: 'Plotly graph', class: 'text-center align-middle' }
            ],
            user_select_fields: { text: "email", value: "uuid" },
            space_select_fields: { text: "name", value: "uuid" },
            graph_data: null,
            loading_graph: false,
        }
    },
    components: {
        alert: Alert,
    },
    methods: {
        filtering(e) {
            if (e.text.length >= 3) {
                this.download_spaces(e.text)
            }
        },
        init() {
            this.download_logs()
            this.download_users()
        },
        show_graph_modal(data) {
            this.loading_graph = true
            this.$bvModal.show('modalPopover')
            this.$http.get(this.$apiURL + '/static_analytic/' + data.item.file_name + '/plotly', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.graph_data = res.data
                    Plotly.react(this.$refs.plotlyGraph, this.graph_data);

                })
                .catch((error) => {
                    //console.log(error.response.data)
                    this.message = {
                        'message': 'Graph generation error with not valid file: ' + error.response.data,
                        'type': "danger"
                    }
                })
                .finally(() => {
                    this.loading_graph = false
                });
        },
        download_log(log_name) {
            this.$http.get(this.$apiURL + '/static_analytic/' + log_name, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.$http.get(res.data.url, { responseType: 'blob' })
                        .then(response => {
                            const blob = new Blob([response.data], { type: 'application/txt' })
                            const link = document.createElement('a')
                            link.href = URL.createObjectURL(blob)
                            link.download = log_name
                            link.click()
                            URL.revokeObjectURL(link.href)
                        }).catch(console.error)
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_logs() {
            this.$http.post(this.$apiURL + '/static_analytic', { space_uuid: this.filter_by_space, user_uuid: this.filter_by_user }, { headers: this.$store.getters.authHeader })
                .then((resp) => {
                    this.list_of_logs = resp.data
                    this.totalRows = this.list_of_logs.length
                })
                .catch((error) => {
                    console.log(error)
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_users() {
            this.$http.post(this.$apiURL + '/admin/users',
                {}, {
                headers: this.$store.getters.authHeader
            })
                .then((resp) => {
                    this.list_of_users = resp.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_spaces(filter) {
            this.$http.get(this.$apiURL + '/spaces/search',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: filter }
                })
                .then((res) => {
                    this.list_of_spaces = res.data.items
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        clear_filter() {
            this.filter_by_space = null
            this.filter_by_user = null
            this.download_logs()
        },
    },
    created() {
        this.init();
    },
}
</script>
